module.exports = __webpack_public_path__ + "static/media/transfer-internal-icon.d1dd01b5.svg";